import { Button, message, Upload } from "antd";
import style from "./index.module.scss";
import { ResultMessage } from "components/ResultMessage";
import React from "react";
import { saveExtraUploadFile } from "service/exam";
import {
    checkCourseWareStr,
    errorMessage,
    uploadToQiNiu
} from "service/service";

interface UploadPageProps {
    stuNo: string; //学号
    examId: string; //考核id
    onChangeUploadLoading: (val: boolean) => void; //附件上传进度
}

export default function UploadPage({
    stuNo,
    examId,
    onChangeUploadLoading
}: UploadPageProps) {
    const { Dragger } = Upload;

    const uploadProps = {
        name: "file",
        multiple: true,
        showUploadList: false, //是否展示文件列表
        customRequest: customerRequest //通过覆盖默认的上传行为，可以自定义自己的上传实现
    };

    //自定义上传方式（不走接口需要先取到file）
    async function customerRequest(e: any) {
        if (checkCourseWareStr(e.file).next) {
            try {
                onChangeUploadLoading(true); //附件上传过程慢，给个loading提示
                const data = await uploadToQiNiu(e.file); //获取上传后七牛地址
                await saveExtraUploadFile(examId, data.url, stuNo);
                message.success("附件上传成功");
                onChangeUploadLoading(false);
            } catch (e) {
                ResultMessage.error(errorMessage(e));
            } finally {
                onChangeUploadLoading(false);
            }
        } else {
            message.error(errorMessage(checkCourseWareStr(e.file).msg));
        }
    }

    return (
        <div className={style.root}>
            <Dragger {...uploadProps}>
                <Button type="link">补充附件</Button>
            </Dragger>
        </div>
    );
}
